import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "@/components/Portfolio";
import Loader from "@/components/Loader";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

import AdminLayout from "@/admin/AdminLayout";
import AdminLogin from "@/admin/Login";
import AdminDashboard from "@/admin/Dashboard";
import AdminProjects from "@/admin/pages/Projects";
import AdminExperience from "@/admin/pages/Experience";
import AdminSkills from "@/admin/pages/Skills";
import AdminEducation from "@/admin/pages/Education";
import AdminCertifications from "@/admin/pages/Certifications";
import AdminAchievements from "@/admin/pages/Achievements";
import AdminHero from "@/admin/pages/Hero";
import AdminContact from "@/admin/pages/ContactInfo";
import AdminResume from "@/admin/pages/Resume";
import AdminSettings from "@/admin/pages/Settings";
import AdminMessages from "@/admin/pages/Messages";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 900);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App">
      <Loader show={loading} />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="hero" element={<AdminHero />} />
              <Route path="projects" element={<AdminProjects />} />
              <Route path="experience" element={<AdminExperience />} />
              <Route path="skills" element={<AdminSkills />} />
              <Route path="education" element={<AdminEducation />} />
              <Route path="certifications" element={<AdminCertifications />} />
              <Route path="achievements" element={<AdminAchievements />} />
              <Route path="resume" element={<AdminResume />} />
              <Route path="contact" element={<AdminContact />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(15, 15, 25, 0.9)",
            border: "1px solid rgba(0, 240, 255, 0.2)",
            color: "#fff",
            backdropFilter: "blur(20px)",
          },
        }}
      />
    </div>
  );
}

export default App;
